import antd from 'ant-design-vue/es/locale-provider/es_ES';
import dayjsLocale from 'dayjs/locale/eu';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/esEu.json';

const components = {
  antLocale: antd,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'eu',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
